





import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import CampaignDashboardView from '@ui/Dashboard/Views/Campaign/CampaignDashboardView'

settings =
  name: 'CampaignDashboardStage'

  resources:
    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'

  vue:
    components: {
      LoadingIndicator,
      CampaignDashboardView,
    }

    computed:
      brandRep: ->
        @campaign?.owner

export default VueOptions.vue settings
